const LayoutWrapper = ({ children }) => {
  return (
    <div className="flex h-screen w-full rounded-v3-md p-v3-md gap-v3-md">{children}</div>
  );
};

export default LayoutWrapper;

